import React, { useContext } from "react";
import { FaFacebookF, FaInstagram, FaWhatsapp } from "react-icons/fa";
import { SiGoogleplay } from "react-icons/si";
import { Link } from "react-router-dom";
import { LanguageContext } from "../../context/LanguageContext";

import "./footer.css";

const Footer = () => {
  const { language } = useContext(LanguageContext);
  return (
    <footer className="footer">
      <div className="footer-container container">
        <div className="footer-row">
          <div className="footer-col-lg-4">
            <h5 className="footer-title">
              {language === "ta" ? (
                <>
                  கோவை கொங்குநாடு <br /> மேட்ரிமோனி
                </>
              ) : (
                <>
                  Kovai Kongunadu <br /> Matrimony
                </>
              )}
            </h5>
            <p className="footer-text">
              Trusted Matrimony platform serving Kongu region. Your perfect
              match is just a click away!
            </p>
          </div>

          <div className="footer-col-lg-4 footer-padding">
            <h6 className="footer-subtitle">Quick Links</h6>
            <ul className="footer-links">
              <li>
                <Link to="/">HOME</Link>
              </li>
              <li>
                <Link to="/premiumplans">PLAN DETAILS</Link>
              </li>
              <li>
                <Link to="/contact">CONTACT US</Link>
              </li>
            </ul>
          </div>

          <div className="footer-col-lg-4">
            <h6 className="footer-subtitle">Follow Us</h6>
            <div className="footer-social-icons">
              <a href="https://www.facebook.com/share/14QgVBab8gJ/" target="_blank" rel="noreferrer">
                <FaFacebookF />
              </a>
              <a href="https://www.instagram.com/kovaikongunadumatrimony" target="_blank" rel="noreferrer">
                <FaInstagram />
              </a>
              <a
                href="https://wa.me/9952676737"
                target="_blank"
                rel="noreferrer"
              >
                <FaWhatsapp />
              </a>
              <a
                href="https://play.google.com/store"
                target="_blank"
                rel="noreferrer"
              >
                <SiGoogleplay />
              </a>
            </div>
          
          </div>
        </div>

        <div className="footer-row" style={{ marginTop: "40px" }}>
          <div className="footer-col-lg-4">
            <h6 className="footer-subtitle">
              {language === "ta" ? "தொடர்புக்கு" : "Contact Us"}
            </h6>
            <p className="footer-text">
              {language === "ta" ? (
                <>
                  முகவரி: 46, மாளவியா வீதி, SNV திருமண மண்டபம் அருகில், ராம்நகர்,
                  <br />
                  கோவை - 641009.
                  <br />
                  மொபைல்: <span className="fw-bold"> +91 9965305393,&nbsp;9952676737,&nbsp; 04224513426 </span> 
                </>
              ) : (
                <>
                  Address: 4-6, Ramar Kovil Street, near SNV Marriage Hall, Ramnagar,
                  <br />
                  Coimbatore - 641009.
                  <br />
                  Mobile: <span className="fw-bold">+91 9965305393,&nbsp; 9952676737,&nbsp; 04224513426</span>
                </>
              )}
            </p>
          </div>
           <div className="footer-col-lg-4">
            <div className="footer-map" style={{ marginTop: "15px" }}>
              <iframe
                title="Kovai Kongunadu Matrimony Location Map"
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3380.907841539413!2d76.96353988537192!3d11.012665661902494!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x26ca107b44c1628b%3A0x6b6f823d6043a0c1!2skovai%20kongunadu%20matrimony!5e1!3m2!1sen!2sin!4v1783529380142!5m2!1sen!2sin"
                width="100%"
                height="350"
                style={{ border: 0, borderRadius: "8px" }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="strict-origin-when-cross-origin"
              ></iframe>
            </div>
            </div>  
        </div>
      </div>

      <div className="footer-bottom">
        <p>© 2025 Kovai Kongunadu Matrimony. All Rights Reserved."</p>
      </div>
    </footer>
  );
};

export default Footer;
